import { render } from "./Index.vue?vue&type=template&id=125d4f40&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=125d4f40&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125d4f40"],['__file',"resources/js/pages/article/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "125d4f40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('125d4f40', __exports__)) {
    console.log('reload')
    api.reload('125d4f40', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=125d4f40&scoped=true", () => {
    console.log('re-render')
    api.rerender('125d4f40', render)
  })

}


export default __exports__